import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API_URL from '../config';
import './ParticipantList.css';

const ParticipantList = () => {
  const { groupId } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchParticipants = async () => {
      try {
        const response = await fetch(`${API_URL}/api/groups/${groupId}/participants`);
        
        if (!response.ok) {
          throw new Error('Group not found');
        }
        
        const result = await response.json();
        setData(result);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchParticipants();
  }, [groupId]);

  if (loading) {
    return (
      <div className="participant-list-container">
        <div className="loading">Laddar...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="participant-list-container">
        <div className="error">
          <h2>Kunde inte hitta gruppen</h2>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  // Hantera både svenska ('ja'/'nej') och engelska ('yes'/'no')
  const attending = data.participants.filter(p => 
    p.response === 'yes' || p.response === 'ja'
  ).sort((a, b) => a.name.localeCompare(b.name, 'sv'));
  
  const notAttending = data.participants.filter(p => 
    p.response === 'no' || p.response === 'nej'
  ).sort((a, b) => a.name.localeCompare(b.name, 'sv'));

  return (
    <div className="participant-list-container">
      
      {/* Header - Gruppnamn */}
      <div className="header">
        <h1>{data.groupName}</h1>
      </div>

      {/* Top Ad - Banner */}
      <div className="ad-container ad-banner">
        <div className="ad-placeholder">
          Annons 728x90
        </div>
      </div>

      {/* Deltagarlista */}
      <div className="participants-section">
        
        {/* De som kommer */}
        <div className="participants-list">
          {attending.map((participant, index) => (
            <div key={`yes-${index}`} className="participant-item">
              {participant.name}
            </div>
          ))}
        </div>

        {/* Streck */}
        {notAttending.length > 0 && (
          <div className="divider"></div>
        )}

        {/* De som inte kommer */}
        {notAttending.length > 0 && (
          <div className="participants-list not-attending">
            {notAttending.map((participant, index) => (
              <div key={`no-${index}`} className="participant-item">
                {participant.name}
              </div>
            ))}
          </div>
        )}

        {/* Totalt antal - efter scroll */}
        <div className="total-count">
          {attending.length} {attending.length === 1 ? 'deltagare' : 'deltagare'} kommer
        </div>
      </div>

      {/* Bottom Ad - Large */}
      <div className="ad-container ad-large">
        <div className="ad-placeholder">
          Annons 336x280
        </div>
      </div>

    </div>
  );
};

export default ParticipantList;
